import React from 'react';

const BuyButton = ({ label, articleNumber, price, currency, quantityFieldId, href, cssClass, onClick }) => (
    articleNumber ? 
    <a className={cssClass} onClick={() => onClick(articleNumber, quantityFieldId, price, currency)}>
        {label}
    </a>
    : <a className={cssClass} href={href}>
        {label}
    </a>
)

export default BuyButton;